<template lang="html">
  <div class="footer row">
    <div class="col-md-5 copyRights">
      &copy;
      {{date}}
      {{translation.footer.allRights}}
      <div class="-text-right">
      </div>
    </div>
    <div class="col-md-7 footer-menu" v-if='showFooter'>
      <span><router-link :to="{name:'registered-vets', params:{ lang: lang}}">{{translation.doctor.doctors}}</router-link></span>
      <span><router-link :to="{name:'about-us', params:{ lang: lang}}">{{translation.aboutUs.about}}</router-link></span>
      <span><router-link :to="{name:'support', params:{ lang: lang}}">{{translation.header.contacts}}</router-link></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data(){
    return {
      translation: message,
      date: null,
      lang: window.lang,
      showFooter: true
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.date = new Date().getFullYear();
    if (localStorage.getItem('userLoggedIn') != undefined || localStorage.getItem('doctorLoggedIn') !=undefined) {
      if (localStorage.getItem('userLoggedIn') || localStorage.getItem('doctorLoggedIn')) {
        if (this.showFooter) {
          this.showFooter = !this.showFooter
        }
      }else {
        this.showFooter = !this.showFooter
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>
@font-face {
  font-family: 'Montserrat-Bold', sans-serif;
  src: url("../assets/fonts/Montserrat-Bold.woff") format("woff");
  font-display: swap;
}
.footer {
  color: #fff;
  margin-top: 6em;
  margin-bottom: 1.5em;
}
.footer .copyRights{
  text-align: left;
}
.footer .footer-menu {
  text-align: right;
}
.footer .footer-menu a {
  font-family: 'Montserrat-Bold';
  color: #fff;
}
.footer .footer-menu a:hover {
  text-decoration: none;
}
.footer .footer-menu span {
  font-size: 1.1em;
  margin-right: 1.5em;
}
.footer .footer-menu span:last-of-type{
  margin-right: 0;
}
.footer a.router-link-active {
   color: #FED154;
}
@media (max-width: 986px) {
.footer .footer-menu span {
    font-size: 1em;
    margin-right: .5em;
  }
}
@media (max-width: 812px) {
.footer .footer-menu span {
    font-size: 1em;
    margin-right: .2em;
  }
}
@media (max-width: 768px) {
    .footer-menu span {
      display: block;
      margin-right: 0!important;
      text-align: center;
    }
    .footer-menu, .copyRights {
      text-align: left;
    }
    .footer-menu {
      display: none;
    }
    .footer .footer-menu span {
      font-size: 1em;
      margin-right: .5em;
    }
    .footer {
      margin-bottom: 9em;
    }
    .faq-container {
      margin-bottom: 1em;
    }
  }
  @media (max-width: 600px) {
    .footer {
      margin-bottom: 9em;
    }
  }

</style>
